import { render, staticRenderFns } from "./featuredProducts.vue?vue&type=template&id=080f2202&scoped=true&"
import script from "./featuredProducts.vue?vue&type=script&lang=js&"
export * from "./featuredProducts.vue?vue&type=script&lang=js&"
import style0 from "./featuredProducts.vue?vue&type=style&index=0&id=080f2202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080f2202",
  null
  
)

export default component.exports